/* eslint-disable */

import { AddOn } from './AddOn';
import { AddOnType } from '../FbbEnum';

export class AddOnMyTV extends AddOn {
	static readonly codeInfo = {
		equipList: 'TVB,1',
	};

	constructor() {
		super();
		this.key = 'AddOnMyTV';

		this.boxIconEn = '';
		this.boxIconZh = '';
		this.boxNameEn = 'My TV Super';
		this.boxNameZh = 'My TV Super';
		this.boxAmount = 100;
		this.hasRedCounter = false;
		/*
        this.landingIcon['en'] = '/img/addon/router.png'
        this.landingIcon['zh'] = '/img/addon/router.png'

        this.landingTitle['en'] = ''
        this.landingTitle['zh'] = ''
        this.landingDesc1['en'] = ''
        this.landingDesc1['zh'] = ''
        this.landingDesc2['en'] = ''
        this.landingDesc2['zh'] = ''
        */
		this.type = AddOnType.SINGLE;
	}

	public isAddOnSelected(): boolean {
		return this.boxCount > 0;
	}
}
